import { getElementFromEvent } from '../utils';

class CoreValue {
	constructor(el, coreValues) {
		this.el = el;
		this.coreValues = coreValues;
		this.button = this.el.querySelector('[data-core-value-toggle]');
		this.target = this.el.querySelector(`[data-core-value-content="${this.button.dataset.coreValueToggle}"]`);
		this.targetImage = this.coreValues.el.querySelector(
			`[data-core-value-image="${this.button.dataset.coreValueToggle}"]`
		);

		this.el.addEventListener('click', (e) => {
			e.preventDefault();

			if (this.el.classList.contains('is-open')) {
				this.close();
			} else {
				this.open();
			}
		});
	}

	open() {
		this.target.style.height = this.target.scrollHeight + 'px';
		this.button?.setAttribute('aria-expanded', true);
		this.el.classList.add('is-open');
		this.coreValues.closeOthers(this);
		this.targetImage && this.targetImage.classList.add('is-active');
	}

	close() {
		this.target.style.height = 0 + 'px';
		this.button?.setAttribute('aria-expanded', false);
		this.el.classList.remove('is-open');
		this.targetImage && this.targetImage.classList.remove('is-active');
	}
}

export default class CoreValues {
	static init(e) {
		const els = e.detail.element.querySelectorAll('[data-core-values]');
		els.forEach((el) => new this(el));
	}

	constructor(el) {
		this.el = el;
		this.coreValues = Array.from(this.el.querySelectorAll('[data-core-value]')).map(
			(el) => new CoreValue(el, this)
		);

		this.coreValues[0]?.open();
	}

	closeOthers(opened) {
		this.coreValues.forEach((coreValue) => {
			if (coreValue !== opened) {
				coreValue.close();
			}
		});
	}
}
